// extracted by mini-css-extract-plugin
export var childrenContainer = "_cr-0";
export var virtualScrollArea = "_cr-1";